import React from 'react';
import './index.less';
import * as PropType from '../common/propType';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import store from '../../store';

type rightBtnType = 'share' | 'backHall' | string | JSX.Element | JSX.Element[] | undefined;

export interface HeaderBasePropType extends PropType.StylePropType {
    prefixCls?: string;
    onBack?: () => void;
    onBtnRightClick?: () => void;
    title?: string;
    btn?: rightBtnType;
}

export interface HeaderBaseState {

}

@observer 
class HeaderBase extends React.Component<HeaderBasePropType, HeaderBaseState> {
    static defaultProps = {
        prefixCls: 'header-base',
        btn: 'share',
    };

    @autobind
    _showBtnRender(btn) {
        const {prefixCls, onBtnRightClick} = this.props;
        let node: any = '';
        if (btn === 'backHall') {
            node = (
                <div className={`${prefixCls}-right-btn-view`}>
                    <i className={`${prefixCls}-btn-back`}/>
                    <p>返回大厅</p>
                </div>
            );
        } else if (btn === 'share') {
            node = (
                <i className={`${prefixCls}-btn-share`}/>
            );
        } else {
            node = btn;
        }
        return (
            <div className={`${prefixCls}-btn`} onClick={onBtnRightClick} style={{width: '4rem', height:'4.3rem' }}>{node}</div>
        );
    }

    render() {
        const {prefixCls, title = '', btn, onBack} = this.props;
        return (
            <div 
                className={`${prefixCls}`} 
                style={{
                    height: store.status.isShowHead ? '5rem' : '4.3rem', 
                    paddingTop: store.status.isShowHead ? '1.4rem' : '0',
                    zIndex: store.status.headZindex
                }}>
                {
                    store.status.isShowLeftBackBtn ?                 
                    <i 
                        className={`${prefixCls}-back`}
                        onClick={onBack}
                    >
                        <img src={require('../../images/back.png')} />
                    </i>
                    : 
                    <i 
                        className={`${prefixCls}-back`}
                        style={{opacity: 0}}
                    >
                        <img src={require('../../images/back.png')} />
                    </i>
                }
                <span className={`${prefixCls}-title`}>{title}</span>
                <div className={`${prefixCls}-btn-box`}>
                    {this._showBtnRender(btn)}
                </div>
            </div>
        );
    }
}

export default HeaderBase;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/header-base/index.tsx